// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drakloak: PokeData = {
  "id": 886,
  "name": "drakloak",
  "height": 14,
  "weight": 110,
  "base_experience": 144,
  "types": [
    PokeType.DRAGON,
    PokeType.GHOST
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "bite",
    "agility",
    "quick-attack",
    "lock-on",
    "astonish",
    "dragon-dance",
    "u-turn",
    "assurance",
    "last-resort",
    "dragon-pulse",
    "dragon-rush",
    "double-hit",
    "hex",
    "phantom-force",
    "infestation"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "dragon-dance",
    "dragon-pulse",
    "dragon-rush",
    "phantom-force",
    "dragon-breath",
    "night-shade",
    "dragon-vortex",
    "shadow-sneak",
    "shadow-ball",
    "spectral-chain",
    "poltergeist"
  ],
  "evolution_chain": {
    "id": 466,
    "item": null,
    "species": [
      {
        "name": "dreepy",
        "order": 885,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drakloak",
        "order": 886,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 885,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dragapult",
        "order": 887,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 886,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 60,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 59,
    "speed": 102,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
